import { AppState } from "../../../index";
import { useDispatch, useSelector } from "react-redux";
import { showModalMessage } from "../../../modalMessage/actions/show";
import { modalMessages } from "../../../modalMessage/messages";
import { useEffect } from "react";
import { confirmAllergies, confirmNoAllergies, getDietaryAllergiesConfirmation, showConfirmDietaryAllergiesModal } from "../../persistence/dietaryAllergiesConfirmation";

const getConfirmDietaryAllergies = (state: AppState) => state.restaurantFlags?.confirmDietaryAllergies;
const getLocationId = (state: AppState) => state.party.activeParty?.restaurantId;
const getPartyId = (state: AppState) => state.party.activeParty?.id;

export const ConfirmDietaryAllergiesModal = () => {
    const confirmDietaryAllergies = useSelector(getConfirmDietaryAllergies);
    const locationId = useSelector(getLocationId) ?? "";
    const partyId = useSelector(getPartyId) ?? "";

    const dispatch = useDispatch();

    useEffect(() => {
        const handleShowModal = async () => {
            if (confirmDietaryAllergies && !getDietaryAllergiesConfirmation(locationId)) {
                await showConfirmDietaryAllergiesModal(locationId, partyId);

                dispatch(
                    showModalMessage(
                        modalMessages.confirmDietaryAllergies(
                            () => confirmNoAllergies(locationId, partyId),
                            () => confirmAllergies(dispatch, locationId, partyId)
                        )
                    )
                );
            }
        };

        handleShowModal();
    }, [dispatch, confirmDietaryAllergies, locationId, partyId]);

    return null;
};
